
import React from "react";
import "../../styles/PrimaryBTN.css";
import { withNamespaces } from 'react-i18next';

const PrimaryBTNWhite = (props) => {
  return (
    <div className={props.alinhar}>
      <button className="learn-more_white">
        <a href={props.link} title={props.title}>
          <span className="circle_white" aria-hidden="true">
            <span className="icon arrow white"></span>
          </span>
          <span className="button-text_white">{props.texto}</span>
        </a>
      </button>
    </div>
  );
};

export default withNamespaces() (PrimaryBTNWhite);

